import { Controller } from 'stimulus'

export default class extends Controller {
  share(event) {
    event.preventDefault()
    $('#modal-dialog').modal()
  }
}
